import { StatisticsBanner, StatisticItem } from '@/shared/components'
import { ConversionBlock } from '@/entities/conversion'
import { formatterRubWithCurrency } from '@/shared/utils'
import { RequisiteModel } from '../../model'
import { RequisiteStatisticModel } from '../../statistic'

type Props = {
  detail: RequisiteModel
  statistic: RequisiteStatisticModel[] | undefined
}

export const RequisiteBanner = ({ detail, statistic }: Props) => {
  const items: StatisticItem[] = [
    {
      label: 'Суточный лимит',
      value: `${detail.maxDailyLimit?.toLocaleString() ?? '0'} RUB`,
    },
    {
      label: 'Общая конверсия',
      value: statistic ? (
        <div className="flex gap-x-1">
          <ConversionBlock current={statistic[0].counterInSuccess} goal={statistic[0].counterIn} />
        </div>
      ) : null,
    },
    {
      label: 'Общая прибыль',
      value: statistic ? formatterRubWithCurrency.format(statistic[0].amountInCommissionRub) : '0 RUB',
    },
    {
      label: 'Мин. сумма сделки',
      value: `${detail.minDealAmount?.toLocaleString() ?? '0'} RUB`,
    },
    {
      label: 'Общий оборот по реквизиту',
      value: statistic ? formatterRubWithCurrency.format(statistic[0].amountInRub) : '0 RUB',
    },
    {
      label: 'Таймаут между сделками',
      value: `${detail.minTimeoutBetweenDealsInMinutes ?? 0} мин`,
    },
  ]

  return (
    <StatisticsBanner
      items={items}
      itemsPerRow={3}
    />
  )
}
